// frontend/src/utils/identitySpec.js
export function identitySpecFromInterview(interview) {
  // Prefer the server-extracted identity_spec (guaranteed accurate, always present on completed interviews)
  if (interview?.identity_spec?.role) {
    return {
      role:  interview.identity_spec.role,
      focus: interview.identity_spec.focus || "Signal extraction in progress",
      edge:  interview.identity_spec.edge  || "Differentiator not yet compressed",
    };
  }

  // Fallback: derive from portfolio JSON fields (handles in-flight interviews)
  const json = interview?.result_json || {};
  const personal = json.portfolio?.personal || {};
  const about = json.portfolio?.about || {};
  return {
    role:  personal.title || json.role  || "Refined Title Pending",
    focus: personal.headline || personal.tagline || json.focus || "Signal extraction in progress",
    edge:  personal.headlineStatement || personal.mantra || about.quote || json.edge || "Differentiator not yet compressed",
  };
}
